// Ephemeral channel types — `docs/architecture/types-and-schemas.md` §4.2.

export type EphemeralType =
  | 'typing'
  | 'stop_typing'
  | 'presence'
  | 'read'
  | 'beacon_tick'
  | 'activity_status'
  | 'call_media_control'
  | 'call_hand_raise'
  | 'call_reaction'
  | 'delivery_ack';

export type PresenceState = 'online' | 'away' | 'dnd' | 'offline';

export interface PresencePayload {
  readonly state: PresenceState;
  readonly custom?: string;
}

export interface ReadPayload {
  readonly max_seq_read: number;
  readonly thread_id?: Uint8Array;
}

export type EphemeralPayload =
  | Record<string, never>
  | PresencePayload
  | ReadPayload
  | Record<string, unknown>;

export interface EphemeralEvent {
  readonly conversationId: Uint8Array;
  readonly senderDevice: Uint8Array;
  readonly epoch: number;
  readonly type: EphemeralType;
  readonly payload: EphemeralPayload;
}

export interface EphemeralSubscribeFrame {
  readonly kind: 'subscribe';
  readonly conversation_ids: string[];
  readonly call_ids?: string[];
}

export interface EphemeralUnsubscribeFrame {
  readonly kind: 'unsubscribe';
  readonly conversation_ids?: string[];
  readonly call_ids?: string[];
}

export type EphemeralErrorCode = 'invalid_request' | 'forbidden' | 'rate_limited';

export interface EphemeralErrorFrame {
  readonly kind: 'error';
  readonly code: EphemeralErrorCode;
}

export const EPHEMERAL_SECRET_LABEL = 'ping/ephemeral';
export const EPHEMERAL_SECRET_LENGTH = 32;
